import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from 'devextreme/ui/dialog';
import { AmsNotifierService } from '../../../../../../../shared/services/ams-notifier.service';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { TimeService } from '../../../../../_api/services/time.service';

@Component({
  selector: 'app-edit-transport-time-addition',
  templateUrl: './edit-transport-time-addition.component.html',
  styleUrls: ['./edit-transport-time-addition.component.css']
})
export class EditTransportTimeAdditionComponent implements OnInit {
  @ViewChild('datagriddx', {static:false}) dataGrid: DxDataGridComponent;
  @Input() gridDataSource: any;
  timeTypeDataSource: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  
  validateHoursMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.23.Hours");
  validateMinutesMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.59.Minutes");

  constructor(public languageService: LanguageService, private timeService: TimeService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    
    this.timeService.getTimeTypes()
      .subscribe((result: any) => { // success path
        
        this.timeTypeDataSource = result;
      }, error => { // error path;        
    });
  }

  onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift( 
          {
            location: 'before',
            template: 'headerTitle'
          },
        {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'trash',
                title: this.languageService.LNG("Label.Delete"),
                onClick: this.onDeleteSelected.bind(this)
            }
        });
  }

  onRowInserting(e) {

  }

  onRowUpdating(e) {

  }

  onDeleteSelected() {
  
  let myDialog = custom({
    title: this.languageService.LNG("Label.Delete"),
    messageHtml: this.languageService.LNG("Label.Do.You.Want.To.Delete.The.Selected.Rows"),
    buttons: [{
        text: this.languageService.LNG("Label.Yes"),
        onClick: (e) => {
            return true;
        }
    }, {
      text: this.languageService.LNG("Label.No"),
      onClick: (e) => {
          return false;
      }
  }, 
    ]
  });
  myDialog.show().then((bConfirm) => {
    
  if (bConfirm) {
    let timeIds: number[] = [];
      let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

      if (selectedRowsData.length > 0) {
        this.loading.emit(true);
        for (let i = 0; i < selectedRowsData.length; i++) {
            timeIds.push(selectedRowsData[i].TimeId);
        }
        
        if (timeIds.length > 0) {
            this.timeService.deleteTimeByTimeIds(timeIds).subscribe((result: any) => { // success path
              
              this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
              if (result.Message != null && result.Message.length > 0) {
                this.amsNotifierService.error(result.Message);
              }
              this.loading.emit(false);
              this.dataGrid.selectedRowKeys = [];
            }, error => { // error path;  
              this.loading.emit(false);
            });
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Delete"));
          this.loading.emit(false);
        }
      }
      else {//delete all
        this.amsNotifierService.info(this.languageService.LNG("Label.Please.Select.Rows.To.Delete"));
        this.loading.emit(false);
        
      }
  }
  });
}

}
